module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGc726f48a01f4b2e89a5011c71dbe7c36.c726f48a.png";